import React from 'react';
import { Card, Row, Col, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { BsShieldCheck, BsGear } from 'react-icons/bs';
import './Dashboard.css';

const Dashboard: React.FC = () => {
  return (
    <Container fluid className="dashboard-container">
      <Row className="mb-4 mt-5 pt-3">
        <Col>
          <h1 className="display-4 mb-4">Tableau de bord de modération Patate</h1>
          <p className="lead text-muted">
            Bienvenue sur le tableau de bord de modération. Retrouvez ici les différents outils à votre disposition.
          </p>
        </Col>
      </Row>

      <Row className="mb-4 g-4">
        <Col md={6} xl={4}>
          <Card className="dashboard-category h-100 shadow-sm">
            <Card.Body className="d-flex flex-column">
              <div className="d-flex align-items-center mb-3">
                <BsShieldCheck className="text-primary" size={26} />
                <h2 className="h5 mb-0 ms-2">Gestion des sanctions</h2>
              </div>
              <p className="text-muted">
                Consultez l'historique et modifiez les raisons de vos sanctions.
              </p>
              <Link to="/sanctions" className="card-link mt-auto">
                Voir les sanctions →
              </Link>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6} xl={4}>
          <Card className="dashboard-category h-100 shadow-sm">
            <Card.Body className="d-flex flex-column">
              <div className="d-flex align-items-center mb-3">
                <BsGear className="text-secondary" size={26} />
                <h2 className="h5 mb-0 ms-2">Paramètres</h2>
              </div>
              <p className="text-muted">
                Configurez le thème et vos préférences d'affichage.
              </p>
              <Link to="/parametres" className="card-link mt-auto">
                Ouvrir les paramètres →
              </Link>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Dashboard;
